import { useAuth } from "src/contexts/AuthContext";
import OnboardingNavbar from "./components/OnboardingNavbar";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

const AccountSelector = () => {
    const { organizations } = useAuth();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0 }
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <header className="bg-white/80 backdrop-blur-lg shadow-sm sticky top-0 border-b border-gray-100">
                {/* <OnboardingNavbar /> */}
                <div className="mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex flex-col md:flex-row justify-between items-start gap-8">
                        <div className="flex-1 space-y-4">
                            <motion.div
                                initial={{ opacity: 0, y: -20 }}
                                animate={{ opacity: 1, y: 0 }}
                                className="flex items-center gap-3"
                            >
                                <div className="p-2 bg-blue-50 rounded-lg">
                                    <svg
                                        className="h-6 w-6 text-blue-600"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                                        />
                                    </svg>
                                </div>
                                <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-primary-700 bg-clip-text text-transparent">
                                    {t("select-organization")}
                                </h1>
                            </motion.div>
                            <motion.p
                                initial={{ opacity: 0, y: -10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.1 }}
                                className="text-lg text-gray-600"
                            >
                                {t("choose-organization-description")}
                            </motion.p>
                        </div>

                        <motion.div
                            initial={{ opacity: 0, scale: 0.95 }}
                            animate={{ opacity: 1, scale: 1 }}
                            className="w-full md:w-auto"
                        >
                            <button
                                onClick={() => {
                                    // Handle creating new organization
                                    console.log("Create new organization");
                                    navigate("/accounts/new");
                                }}
                                className="w-full md:w-auto group flex items-center gap-4 bg-white rounded-xl border border-gray-200 py-4 px-8 hover:bg-gray-50 hover:border-blue-200 transition-all duration-200 shadow-sm hover:shadow"
                            >
                                <div className="h-12 w-12 rounded-lg bg-gradient-to-br from-blue-50 to-primary-50 flex items-center justify-center border border-blue-100 group-hover:border-blue-300 transition-colors">
                                    <svg className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                                    </svg>
                                </div>
                                <div className="flex flex-col items-start space-y-2">
                                    <h3 className="text-lg font-semibold text-gray-900">
                                        {t("create-new-organization")}
                                    </h3>
                                    <p className="text-sm text-gray-500">
                                        {t("setup-new-workspace")}
                                    </p>
                                </div>
                            </button>
                        </motion.div>
                    </div>
                </div>
            </header>

            <main className="mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
                >
                    {organizations.map((org) => (
                        <motion.button
                            key={org.id}
                            variants={itemVariants}
                            onClick={() => {
                                localStorage.setItem("currentOrganization", JSON.stringify(org));
                                window.dispatchEvent(new CustomEvent("organizationChanged", {
                                    detail: { organization: org }
                                }));
                                navigate("/"); // Change this to your actual route
                                window.location.reload();
                            }}
                            className="group flex items-center gap-6 bg-white rounded-xl border border-gray-200 p-6 hover:bg-gray-50 hover:border-blue-200 transition-all duration-200 shadow-sm hover:shadow text-left"
                        >
                            <div className="h-16 w-16 rounded-xl bg-gradient-to-br from-blue-50 to-primary-50 flex items-center justify-center border border-blue-100 group-hover:border-blue-300 transition-colors">
                                <span className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-primary-600 bg-clip-text text-transparent">
                                    {org.name[0].toUpperCase()}
                                </span>
                            </div>
                            <div className="  space-y-2">
                                <h3 className="text-xl font-semibold text-gray-900">
                                    {org.name}
                                </h3>
                            </div>
                        </motion.button>
                    ))}
                </motion.div>
            </main>
        </div>
    );
};

export default AccountSelector;